"use client";
import { t as x } from "./tv.config-BuYIgndg.mjs";
import { h as o } from "./helpers-DV5vPbCU.mjs";
import b from "react";
import { u as y } from "./useRender-DCcXqLqs.mjs";
import { m as v } from "./useRenderElement-B8V3_e8R.mjs";
const B = x({
  base: ["Typography__root normal-case drop-shadow-sm"],
  variants: {
    variant: {
      h1: "text-[2.5rem] font-bold",
      h2: "text-3xl font-bold",
      h3: "text-2xl font-semi-bold",
      h4: "text-[1.375rem] font-semi-bold",
      h5: "text-xl font-medium",
      h6: "text-lg font-medium",
      subtitle1: "text-lg font-normal",
      subtitle2: "text-lg font-normal",
      body1: "text-sm",
      body2: "text-sm font-light",
      caption: ["text-xs font-light"],
      overline: ["text-xs uppercase tracking-widest font-light"],
      inherit: "text-inherit"
    },
    weight: {
      light: "font-light",
      regular: "font-normal",
      medium: "font-medium",
      bold: "font-bold"
    },
    italic: {
      true: ["italic"]
    },
    truncate: {
      true: ["truncate"]
    },
    textTransform: {
      uppercase: ["uppercase"],
      lowercase: ["lowercase"],
      capitalize: ["capitalize"]
    },
    align: {
      left: "text-left",
      right: "text-right",
      center: "text-center",
      inherit: "text-inherit"
    },
    gutterBottom: {
      true: ["mb-4"]
    },
    color: {
      primary: ["text-primary-main"],
      secondary: ["text-secondary-main"],
      success: ["text-success-main"],
      warning: ["text-warning-main"],
      info: ["text-info-main"],
      error: ["text-error-main"],
      inherit: ["text-inherit"]
    }
  },
  compoundVariants: [
    {
      variant: "h1",
      gutterBottom: !0,
      className: "mb-2"
    },
    {
      variant: "h2",
      gutterBottom: !0,
      className: "mb-2"
    },
    {
      variant: "h3",
      gutterBottom: !0,
      className: "mb-2"
    },
    {
      variant: "h4",
      gutterBottom: !0,
      className: "mb-2"
    },
    {
      variant: "h5",
      gutterBottom: !0,
      className: "mb-2"
    },
    {
      variant: "h6",
      gutterBottom: !0,
      className: "mb-2"
    }
  ],
  defaultVariants: {
    variant: "body1",
    fontWeight: "regular"
  }
}), w = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  caption: "span",
  overline: "span",
  inherit: "p"
};
function N(e) {
  const {
    render: a,
    children: t,
    variant: r = "body1",
    component: i,
    align: s,
    weight: m,
    className: l,
    paragraph: n,
    gutterBottom: h,
    color: c,
    forceVariant: u,
    ...p
  } = e, g = typeof t == "string" && o(t) ? u ? r : "div" : i || (n ? "p" : w[r]), d = a ?? b.createElement(g), f = {
    className: B({
      variant: r,
      className: l,
      align: s,
      weight: m,
      color: c,
      gutterBottom: n ? !0 : h
    }),
    ...typeof t == "string" && o(t) ? { dangerouslySetInnerHTML: { __html: t } } : { children: t }
  };
  return y({
    render: d,
    props: v(f, p)
  });
}
const H = (e) => N(e);
export {
  H as default
};
